import Portfolio7 from './Portfolio7'
export default Portfolio7
